import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';
import { MembershipCancelReason } from './MembershipCancelReasonsService';

const URL = '/v2/sitter-membership-cancel';

export interface SitterMembershipCancelRequest {
  sitterId: number;
  userPlanId: number;
  reason: MembershipCancelReason;
  cancelText?: string;
}

class SitterMembershipCancelService {
  static create(
    data: SitterMembershipCancelRequest,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<unknown>> {
    return axios.post(URL, data, config);
  }
}

export { SitterMembershipCancelService };
